import React, { Component } from "react";
import "./index.css";
import { withRouter } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      info: null,
      setTimeoutId: null,
      seconds: 3000
    };
  }

  goTo = url => {
    this.props.history.push(url);
    document.location.reload();
  };

  componentDidCatch(error, info) {
    this.setState({
      error,
      info
    });
    const id = setTimeout(() => {
      this.goTo("/home");
    }, this.state.seconds);
    this.setState({
      setTimeoutId: id
    });
  }

  componentWillUnmount() {
    clearTimeout(this.state.setTimeoutId);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <h1>Ocurrio algo!</h1>
          <h2>
            {`Seras redirigido al incio en ${this.state.seconds /
              1000} segundos. Si no te ha enviado al inicio pulsa `}
            <a href="/home">Aqui</a>
          </h2>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
